import { Box, DialogContentText } from '@mui/material';
import { Dispatch, FC, SetStateAction } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';

import { UserMin } from '@apiContract';

import UserList from '@components/UserList';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';

type Props = {
  isOpened: boolean;
  setIsOpened: Dispatch<SetStateAction<boolean>>;
  usersToConfirm: UserMin[];
  onConfirmationClick: () => void;
};

const LocationRecipients: FC<Props> = ({ isOpened, usersToConfirm, setIsOpened, onConfirmationClick }) => {
  return (
    <DialogConfirmation
      maxWidth="xs"
      open={isOpened}
      handleClose={() => setIsOpened(false)}
      type="success"
      title="Change location"
      content={
        <Box minHeight="300px">
          <DialogContentText sx={{ mb: 1 }}>
            The recipients below are already assigned to a location. Are you sure you would like to change their
            location to this one? This change will only take effect after you save your changes.
          </DialogContentText>
          <Box minHeight="200px">
            <AutoSizer>
              {({ height, width }) => <UserList height={height} width={width} users={usersToConfirm} />}
            </AutoSizer>
          </Box>
        </Box>
      }
      acceptButtonTitle="Change Location"
      acceptButtonHandleClick={onConfirmationClick}
      cancelButtonTitle="Go Back"
      cancelButtonHandleClick={() => setIsOpened(false)}
    />
  );
};

export default LocationRecipients;
